import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { EmployeeOption } from '../tasks.types';

export default function EmployeePicker({
  employees,
  value,
  onChange,
  label = 'Employee',
  exclude,
  required,
}: {
  employees: EmployeeOption[];
  value: number | null;
  onChange: (id: number | null) => void;
  label?: string;
  exclude?: number | null;
  required?: boolean;
}) {
  const options = employees.filter((e) => e.id !== exclude);
  return (
    <Autocomplete
      options={options}
      value={options.find((e) => e.id === value) ?? null}
      onChange={(_, v) => onChange(v?.id ?? null)}
      getOptionLabel={(e) => `${e.name}${e.departmentName ? ` · ${e.departmentName}` : ''}`}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      renderInput={(p) => <TextField {...p} label={label} required={required} size='small' />}
    />
  );
}
